module.exports = __webpack_public_path__ + "static/media/scale3.edb71512.png";